import React from 'react';


const FormulaLoader = ()=>{
    return (
    
<div class="formula-loading"><div class="formula-loader">
<div></div>
</div></div>
    )
}
export default FormulaLoader; 